import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { CreatePartnerForm } from '../CreatePartnerForm'
import NavigateBackButton from '@/common/components/NavigateBackButton'
export default function CreatePartnerListing() {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading title={`สร้างพาร์ทเนอร์`} description="สร้างพาร์ทเนอร์" />
				<NavigateBackButton />
			</div>
			<Separator />
			<CreatePartnerForm />
		</div>
	)
}
